import { render } from "./PartsAboutOsakazai.vue?vue&type=template&id=446b9c4d"
import script from "./PartsAboutOsakazai.vue?vue&type=script&lang=js"
export * from "./PartsAboutOsakazai.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__